import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { StartEndSettingsPageSkeleton } from './StartEndSettingsPageSkeleton';
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex'
  },
  sidebar: {
    width: 200,
    marginTop: theme.spacing(3.5),
    borderRight: '1.5px solid rgb(219, 219, 219)'
  },
  startEndTime: {
    width: '100%',
    height: 45,
    marginTop: theme.spacing(-1),
    background: theme.skelton?.color
  },
  settingPage: {
    marginLeft: 10,
    width: 1200
  }
}));
export const SettingsPageSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.settingPage}>
        <StartEndSettingsPageSkeleton />
      </Box>
    </Box>
  );
};
